module.exports = __webpack_public_path__ + "img/Testimoni_Akulaku.7c36ac82.png";